import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
        <g>
          <path
            fill="#336BC4"
            d="M55 39.1c-.6 1.5-1.6 2.9-2.4 4.3-1.5 2.7-3.1 5.3-4.6 8-.3.4-.5.8-1.1.8H16.3c-.1 0-.2 0-.3-.1 1.5-2.6 3-5.3 4.5-7.9 1-1.7 1.8-3.5 3.1-5H40c5-.1 10-.1 15-.1z"
          />
          <path
            fill="#FFCE00"
            d="M55 39.1H40.1c-.5-.8-.9-1.6-1.4-2.4-2.3-3.9-4.5-7.9-6.8-11.8-2.4-4.2-4.8-8.5-7.2-12.7.3-.3.7-.2 1.1-.2h12.6c.6 0 1 .2 1.3.8 5 8.5 9.9 17 14.9 25.4.2.3.3.6.4.9z"
          />
          <path
            fill="#25C15D"
            d="M24.7 12.1c2.4 4.2 4.8 8.5 7.2 12.7-.5.8-1 1.6-1.4 2.4-2.3 4-4.6 7.9-6.8 11.9-1.3 1.5-2.1 3.3-3.1 5-1.5 2.6-3 5.3-4.5 7.9-1.6-2.5-2.9-5.2-4.4-7.8-.8-1.5-1.6-2.9-2.4-4.4-.2-.4-.3-.7 0-1.1 5.1-8.8 10.3-17.6 15.4-26.5-.1 0 0-.1 0-.1z"
          />
        </g>
      </svg>
    </>
  ),
  'GoogleDrive',
  '0 0 120 120'
);
